import React, { useState } from "react";
import "./CarouselSlider.css";
import Carousel from "react-material-ui-carousel";
import { Grid, Typography, Button, Box, Divider, Modal } from "@mui/material";
import tornadosmall  from "../../../../assets/home-slider-assets/tornado-one-small.png"
import floodsmall  from "../../../../assets/home-slider-assets/flood-small.png"
import fireathomesmall  from "../../../../assets/home-slider-assets/fireathome-small.png"
import activeShootersmall from "../../../../assets/home-slider-assets/activeShooter-small.png"
import caraccidentsmall  from "../../../../assets/home-slider-assets/caraccident-small.png"
import tornado from "../../../../assets/home-slider-assets/tornado-one.png";
import flood from "../../../../assets/home-slider-assets/flood.png";
import ActiveShooter from "../../../../assets/home-slider-assets/activeShooter.png";
import Fireathome from "../../../../assets/home-slider-assets/fireathome.png";
import CarAccident from "../../../../assets/home-slider-assets/caraccident.png";
import individual from "../../../../assets/icons/individual-icon.svg";
import business from "../../../../assets/icons/business-icon.svg";
import goverment from "../../../../assets/icons/goverment-icon.svg";
import rightarrow from "../../../../assets/icons/right-arrow-white-icon.svg";
import leftarrow from "../../../../assets/icons/left-arrow-white-icon.svg";
import message from "../../../../assets/icons/message-icon.svg";
import HomepageModal from "../HomepageModal";
import { useNavigate } from "react-router-dom";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import './styles/slickSlider.css';
import offerbtn from "../../../../assets/offer-logo.png";
import InitializeModal from "./InitializeModal";
export default function CarouselSlider(props) {
  const [offerOpen, setOfferOpen] = useState(false)
  const handleCloseoffer = () => setOfferOpen(false);
  const handleOpenoffer = () => setOfferOpen(true);
  var items = [
    {
      image: flood,
      picture:floodsmall,
      content:"Your family will be prepared with a clear understanding of the necessary measures to take and the safe places to go to during any emergency or disaster situation"
  
    },
    {
      image: tornado,
      picture:tornadosmall,
      content:"Your family’s legacy and dear memories are safeguarded through a robust and thoughtful preservation strategy"
  
    },
    {
      image: Fireathome,
      picture:fireathomesmall,
      content:"Is your family ready when the disaster occurs?"
  
    },
    {
      image: CarAccident,
      picture:caraccidentsmall,
      content:"MYREDFOLDER® keeps important documents together such as your insurance and registration in one place and provides tools to handle the aftermath of a car accident effectively, reducing stress and improving your overall preparedness. "
  
    },
    {
      image: ActiveShooter,
      picture:activeShootersmall,
      content:"Locate and communicate with your loved ones in times of an emergency"
  
    },
  ];

  const settings = {

    arrows: true,
    autoplay: true,
    autoplaySpeed: 3500,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    
  }
  const modalitems = [
    {
      image: individual,
      title: "For Individual",
      content: `The MYREDFOLDER® is an innovative, comprehensive emergency preparedness, response, and recovery solution designed to ensure individuals, families, and organizations are fully prepared for any unexpected event. This unique system consolidates critical personal, medical, and legal documents along with emergency plans and contacts in one easily accessible, secure, and in a digital format.<br/><br/> During an emergency, when phone calls might fail, the app's chat feature becomes a lifeline, allowing families to share updates, comfort, and crucial information, keeping the lines of communication open when it matters most. And for those moments when someone is in dire need of assistance, the 'I Need Help' alert function sends out a beacon to all family members, signaling for help with the push of a button.<br/><br> With MYREDFOLDER®, users can quickly access essential information in the event of a natural disaster, medical emergency, or any situation requiring immediate access to vital documents or emergency services. It's not just about being organized; it's about being ready for anything, ensuring peace of mind knowing that you and your loved ones are prepared for the unexpected.<br><br/> In its resource repository, you'll find up-to-date information on evacuation routes, nearby shelters, and emergency services. It's your go-to source for critical information during crises. The app integrates seamlessly with local emergency services, allowing you to call for help right from the app. It provides details on the nearest medical facilities and offers first-aid guidelines. MYREDFOLDER® keeps you informed with real-time alerts from official sources, delivering weather updates, disaster warnings, and other vital information.<br/><br/> With its user-friendly interface, MYREDFOLDER® isn't just an app; it's your family's guardian angel, ensuring you're prepared, connected, and informed during emergencies. Embrace peace of mind like never before with MYREDFOLDER®.`,
      link:'/pricing',
      key:null,
      className:'individual-img'
    },
    {
      image: business,
      title: "For Business",
      content: "By offering the MYREDFOLDER® Plan to both employees and customers, your company demonstrates a strong commitment to safety, preparedness, and customer care. Providing an emergency plan to employees equips them with the knowledge and tools necessary to protect themselves and their families during crises, fostering a sense of security and loyalty. This leads to increased employee morale, productivity, and retention. Moreover, extending this plan to customers showcases your company’s dedication to their well-being, building trust and brand reputation. It serves as a unique selling point, differentiating your business from competitors and attracting safety-conscious customers. The provision of an emergency preparedness/recovery plan not only safeguards lives but also enhances your company’s image as a responsible and customer-oriented organization, contributing to long-term success and positive community engagement",
      link:'',
      key:"business",
      className:'individual-img'
    },

    {
      image: goverment,
      title: "For Government",
      content: "By offering the MYREDFOLDER® to the community, local or state governments demonstrate their commitment to public safety and preparedness. Providing an accessible and comprehensive emergency plan equips residents with the necessary knowledge and resources to protect themselves and their families during emergencies and natural disasters. This proactive approach enhances the government’s reputation as a responsible and caring entity that prioritizes the well-being of its citizens. By taking the lead in emergency preparedness, governments build trust, foster a sense of community resilience, and instill confidence in their ability to effectively respond to and mitigate potential crises. The provision of an emergency plan not only improves the government’s image and public perception but also strengthens community engagement and fosters a positive relationship between residents and their local or state authorities. If you are a government agency CONTACT US today for more information.",
      link:'',
      key:'goverment',
      className:'goverment-img'
    }
  ]


  return (
    <Grid containter>
      <Grid item xs={12} md={12} lg={12} sx={{background:"black"}}>
      <div className="offer-button"  
      //  onClick={handleOpenoffer}
        // style={{zIndex:100, position: "fixed", top: "40%", right: "-155px" }}
        >
          <img
          className="offerlimited-btn"
            src={offerbtn} onClick={handleOpenoffer}
            style={{  cursor: "pointer" }}
            alt="text"
          />
        </div>
        
        <InitializeModal open={offerOpen} onClose={handleCloseoffer} />
        <Carousel
         fullHeightHover={false}   
          NextIcon={<img className="arrows-carousal" src={rightarrow} alt="text" />}
          animation={"fade"}
          duration={500}
          autoPlay={true}
          className="slider-icon"
          PrevIcon={<img className="arrows-carousal"  src={leftarrow} alt="text" />}
          indicators={false}
          navButtonsAlwaysVisible={Boolean}
        >
          {items.map((item, i) => (
            <Item key={i} item={item} />
          ))}
        </Carousel>
  {/* <Slider className="custom-slider"
    {...settings}
              >
       {items.map((item, i) => (
            <Item key={i} item={item} />
          ))}
      </Slider> */}

      </Grid>
      <Grid item
          sx={{ alignItems:"center",py:"16px"}}
          className="carousal-bottom"
          lg={12}
          sm={12}
          xs={12}
        >
          
        <Typography  className="primary-font-medium-3">
          Near absolute emergency preparedness, response, and recovery protocols
          for all.
          <br />
          Because everyone deserves to be in total control of their life
          </Typography>
        </Grid>
      <Grid item
        container
        // sx={{ py:"50px",background:"#FAFAFB",opacity:"1"}}
        className="individual-container"
      >
        {/* <Grid item xs={2} md={1} lg={1}></Grid> */}
        <div className="individual-container-root"> 
        <Grid item   container  className="invidual-item-container" >
          {modalitems.map((item, i) =>
            <Popup key={i} data={item} />

          )}

        </Grid>
</div>
        {/* <Grid item xs={2} md={1} lg={1}></Grid> */}
      </Grid>
    </Grid>
  );
}

function Item(props) {
  // const [offerOpen, setOfferOpen] = useState(false)
  // const handleCloseoffer = () => setOfferOpen(false);
  // const handleOpenoffer = () => setOfferOpen(true);
  const navigate=useNavigate();

  return (
    <>
      <Grid 
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          background:"black !important"
        }}
      >
        <Grid lg={12} xs={12} sm={12} >
          <img
          className="carousal-img-bigsize"
        
            src={props.item.image}
            alt="slide"
          />
          <img
             className="carousal-img-smallsize"
         
            src={props.item.picture}
            alt="slide"
          />
        </Grid>
        <div className="contactus-button" 
        // style={{ position: "fixed", top: "35%", right: "-10px" }}
        >
          <img
            src={message}
            style={{ height: "60px", width: "60px", cursor: "pointer" }}
            alt="text"
          />
        </div>
        {/* <div className="offer-button"  onClick={handleOpenoffer}
        style={{ position: "fixed", top: "40%", right: "-155px" }}
        >
          <img
            src={offerbtn}
            style={{  width: "70%", cursor: "pointer" }}
            alt="text"
          />
        </div> */}
       
        <Grid item
          // sx={{
          //   display: "flex",
          //   flexDirection: "column",
          //   position: "absolute",
          //   bottom: "25%",
          // paddingBottom:"20px",
          // paddingX:"80px",
          //   minWidth: "50%",
          // }}
          className="carousal-middle-container"
        >
          <Typography
            // sx={{
            //   color: "#ffffff",
            //   py: "26px",
            //   textAlign: "center",
            //   opacity: "1",
            // }}
            className="carousal-middle-content primary-font-bold18"
          >
            {" "}
           {props.item.content}{" "}
          </Typography>
          <Typography
            // sx={{ paddingBottom: "15px ", color: "#FFFFFF", textAlign: "center" }}
            className=" carousal-middle-content-1 primary-font-medium-10"
          >
           MYREDFOLDER® - The only LIVE INTERACTIVE Family Emergency Plan by NEPTA
            
          </Typography>
          <Button
         onClick={() =>{navigate("/pricing")}}
            // variant="outlined"
            // sx={{
            //   width: '220px',
            //   height: '60px',
            //   "&:hover": {
            //     backgroundColor: "#ff3535",
            //     color: "#ffffff",
            //     borderColor: "#ff3535",
            //   },
            // }}
            className="getting-started primary-font-bold19"
          >
            {" "}
            Coming Soon!
          </Button>
        </Grid>
     
      </Grid>
    
    </>
  );
}
function Popup(props) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
   
    <Grid item  className=" Home indvidualcontainer-topbar" >
      <Box  onClick={() => { setOpen(!false) }}  className=" Home indvidualcontainer"  sx={{':hover': { boxShadow: 3}}} >
          <img src={props.data.image} alt="text" className= {props.data.className} style={{float:"left"}} />
          <Typography  className=" primary-font-medium-4" sx={{mt:"9px"}}> {props.data.title} </Typography>
        </Box>

      <HomepageModal
        close={handleClose}
        open={open}
        data={props.data} />
        
    </Grid>
   
  )
}
